import React, { useEffect, useState } from "react";
import { getSessions } from "../services/api";

export default function SessionsMonitor() {
  const [sessions, setSessions] = useState([]);
  const [lastUpdated, setLastUpdated] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    try {
      setLoading(true);
      const data = await getSessions();
      setSessions(data);
      setLastUpdated(new Date().toLocaleTimeString());
    } catch (err) {
      console.error("Error loading sessions:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    const interval = setInterval(fetchData, 60000); // auto refresh every 1 minute
    return () => clearInterval(interval);
  }, []);

  const getColor = (status) => {
    if (status === "green") return "green";
    if (status === "amber") return "orange";
    return "red";
  };

  if (loading) return <p>Loading...</p>;

  return (
    <div>
      <div style={styles.header}>
        <h2>Session Health Monitor</h2>
        <div style={styles.updateSection}>
          <span>Last Updated: {lastUpdated}</span>
          <button style={styles.refreshBtn} onClick={fetchData}>
            Refresh Now
          </button>
        </div>
      </div>

      <div style={styles.grid}>
        {sessions.map((s) => (
          <div key={s.B2BID} style={{ ...styles.card, borderLeft: `5px solid ${getColor(s.Status)}` }}>
            <h3>{s.B2BID}</h3>
            <p>
              <strong>Status:</strong>{" "}
              <span style={{ color: getColor(s.Status) }}>{s.Status.toUpperCase()}</span>
            </p>
            <p>
              <strong>Last Session:</strong>{" "}
              {new Date(s.LastSession).toLocaleString()}
            </p>
            <p>
              <strong>Time Diff:</strong> {s.DiffMinutes} min
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}

const styles = {
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "20px",
  },
  updateSection: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  refreshBtn: {
    background: "#2563eb",
    color: "#fff",
    border: "none",
    padding: "6px 12px",
    borderRadius: "6px",
    cursor: "pointer",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
    gap: "20px",
  },
  card: {
    background: "#fff",
    padding: "15px",
    borderRadius: "10px",
    boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
  },
};
